<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <h2 class="m-0">{{'RAWDATA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8">
            <span>{{'RAWDATA.SUBTITULO' | translate}}</span>
          </div>
          <!-- / CONTENT TOOLBAR -->
          <div class="changelog w100 p-20" fxFlex>
            <div class="" fxLayout="row" fxLayoutAlign="start stretch">

              <ng-container *ngFor="let campo of campos">
                <mat-form-field appearance="outline" [fxFlex]="30" class="mr-20" *ngIf="campo.activo == true">
                  <mat-label>{{'RAWDATA.CAMPOS.' + campo.clave | translate}}</mat-label>

                  <!-- <mat-select [(ngModel)]="valores[campo.clave]" [disabled]="buscando" (selectionChange)="campo.funcion != undefined ? [this[campo.funcion](), getRawDatas($event.value)] : getRawDatas($event.value)"> -->
                  <!-- <mat-select [(ngModel)]="valores[campo.clave]" [disabled]="buscando" (selectionChange)="verDatos()"> -->
                  <mat-select [(ngModel)]="valores[campo.clave]" [disabled]="buscando" (selectionChange)="campo.funcion != undefined ? [this[campo.funcion](), getRawDatas()] : getRawDatas()">
                    <ng-container *ngIf="campo.catalogo">
                      <mat-option *ngFor="let opcion of campo.catalogo" [value]="opcion.anio">
                        {{opcion.traducible == undefined ? opcion.anio : 'RAWDATA.CATALOGOS.' + campo.clave + '.' + opcion.anio | translate}}
                      </mat-option>
                    </ng-container>
                  </mat-select>

                  <mat-icon matSuffix class="secondary-text">{{campo.icono}}</mat-icon>
                </mat-form-field>
              </ng-container>

              <mat-form-field appearance="outline" fxFlex="30" *ngIf="busquedaIniciada && buscando == false && totalResultados > 0">
                <input matInput (keyup)="applyFilter($event)" placeholder="{{'RAWDATA.FILTER' | translate}}" #input>
              </mat-form-field>
            </div>

            <ng-container *ngIf="busquedaIniciada">
              <div fxLayout="column" fxLayoutAlign="start center" class="p-20" *ngIf="buscando == true" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <p>{{'RAWDATA.RESULTADOS.CARGANDO' | translate}}</p>
                <div class="spinnerCGO"></div>
              </div>
              <div *ngIf="buscando == false" fxLayout="column" fxLayoutAlign="start center" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <h1>{{'RAWDATA.RESULTADOS.TITULO' | translate}}</h1>
                <ng-container *ngIf="totalResultados > 0; else sinResultados">
                  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
                  <table mat-table [dataSource]="resultados" class="w100">

                    <ng-container matColumnDef="nombre">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.nombre' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        <b>{{empresa.NombreEmpresa}}</b>
                      </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="tipoProducto">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.producto' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        {{empresa.tipoProducto}}
                      </td>
                    </ng-container> -->

                    <ng-container matColumnDef="surveytoken">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.surveytoken' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        <b>{{empresa.SurveyToken}}</b>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="tiporawdata">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.tiporawdata' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        <b>{{empresa.Rdtatype}}</b>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="fecha">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.fecha' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        {{empresa.FechaHoraUTC0_Cierre}}
                        <!-- {{empresa.FechaHoraUTC0_Cierre|date:"d MMM y H:mm":offsetPipe:idiomaUtc}} ({{empresa.FechaHoraUTC0_Cierre|date:'z':offsetPipe:idiomaUtc}}) -->
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef>{{'RAWDATA.COLUMNAS.acciones' | translate}}</th>
                      <td mat-cell *matCellDef="let empresa; let i = index;">
                        <ng-container *ngIf="empresa.urlText != null; else sinArchivo">
                          <a color="primary" class="m-5" mat-mini-fab matTooltip="{{'RAWDATA.DOWNLOADFILE' | translate}}" [matTooltipClass]="'tooltips'" [matTooltipPosition]="'right'" [href]="empresa.urlText" target="_blank" download>
                            <mat-icon>arrow_downward</mat-icon>
                          </a>
                        </ng-container>
                        <ng-template #sinArchivo>
                          <em>{{'RAWDATA.NOFILE' | translate}}</em>
                        </ng-template>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnasResultado"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnasResultado;"></tr>
                  </table>

                </ng-container>
                <ng-template #sinResultados>
                  <h2><em>{{'RAWDATA.RESULTADOS.SINRESULTADOS' | translate}}</em></h2>
                </ng-template>

              </div>
            </ng-container>
          </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
